import React from 'react'

import {cssTheme} from '@vio/atlas/src/themes'

export const PriceTrendUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <rect
      width={36}
      height={36}
      fill={cssTheme.colors.background.danger.tertiary}
      rx={18}
    />
    <path
      fill={cssTheme.colors.content.danger.primary}
      d="M22.167 13.354a.804.804 0 0 0-.593.24.804.804 0 0 0-.24.594c0 .236.08.433.24.593.16.16.357.24.593.24H23.5l-4.333 4.292-2.75-2.75a.864.864 0 0 0-.583-.23.784.784 0 0 0-.313.063 1.094 1.094 0 0 0-.27.167l-5.021 5.062a.765.765 0 0 0-.23.563.8.8 0 0 0 .25.583.79.79 0 0 0 .584.23.79.79 0 0 0 .583-.23l4.417-4.417 2.75 2.75a.736.736 0 0 0 .27.178.93.93 0 0 0 .313.052.93.93 0 0 0 .313-.052.736.736 0 0 0 .27-.178l4.917-4.916v1.333c0 .236.08.434.24.594.16.16.357.24.593.24s.434-.08.594-.24c.16-.16.24-.358.24-.594v-3.333a.804.804 0 0 0-.24-.594.804.804 0 0 0-.594-.24h-3.333Z"
    />
  </svg>
)
